/* istanbul ignore file */
export * from './VoucherPrice';
